<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="27.859"
    viewBox="0 0 16 27.859"
  >
    <g class="a" fill="none" transform="translate(-29.397)">
      <path
        class="b"
        stroke="none"
        d="M29.4,27.859V0h16V27.634l-7.865-6.526L29.4,27.856Z"
      />
      <path
        class="c"
        stroke="none"
        :fill="color"
        d="M 32.39669418334961 21.47046661376953 L 35.61636352539062 18.79857635498047 L 37.53218460083008 17.20870590209961 L 39.44801330566406 18.79857635498047 L 42.39669418334961 21.24558639526367 L 42.39669418334961 3.000005960464478 L 32.39669418334961 3.000005960464478 L 32.39669418334961 21.47046661376953 M 29.39669418334961 27.8585262298584 L 29.39669418334961 27.85560607910156 L 29.39669418334961 5.975952262815554e-06 L 45.39669418334961 5.975952262815554e-06 L 45.39669418334961 27.63366508483887 L 37.53218460083008 21.10717582702637 L 29.39917373657227 27.85647583007812 L 29.39669418334961 27.8585262298584 Z"
      />
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'BookMark',
    props: {
      color: {
        type: String,
        default: '#3c3d3e',
      },
    },
  }
</script>

<style scoped>
  svg {
    width: 16px;
    height: 27.859px;
  }
</style>
